/* Mix & Match Gruppe im Warenkorb (Goldi, ab 01.10.2026)
   +/- je Zeile nutzt Ellas updateQuantity (cart-drawer-items / cart-items-component),
   X entfernt alle Gläser der Gruppe auf einmal. Danach meldet es sich beim Builder (mixmatch:cart-changed). */
(() => {
  if (window.__mmCartBound) return;
  window.__mmCartBound = true;

  const notify = () => document.dispatchEvent(new CustomEvent('mixmatch:cart-changed'));

  document.addEventListener('click', async (event) => {
    const group = event.target.closest('[data-mm-cart-group]');
    if (!group) return;
    const items = group.closest('cart-drawer-items, cart-items-component');

    const lineEl = event.target.closest('.mm-cart__line');
    const plus = event.target.closest('[data-mm-line-plus]');
    const minus = event.target.closest('[data-mm-line-minus]');
    if (lineEl && (plus || minus) && items?.updateQuantity) {
      event.preventDefault();
      const line = Number(lineEl.dataset.line);
      const quantity = Math.max(0, Number(lineEl.dataset.qty) + (plus ? 1 : -1));
      group.classList.add('is-loading');
      await items.updateQuantity({ line, quantity, action: quantity === 0 ? 'clear' : 'change' });
      notify();
      return;
    }

    if (event.target.closest('[data-mm-group-remove]')) {
      event.preventDefault();
      const updates = {};
      (group.dataset.variantIds || '').split(',').filter(Boolean).forEach((id) => { updates[id] = 0; });
      group.classList.add('is-loading');
      const drawer = document.querySelector('cart-drawer');
      const body = { updates };
      if (drawer) {
        body.sections = drawer.getSectionsToRender().map((s) => s.id).join(',');
        body.sections_url = window.location.pathname;
      }
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const cart = await res.json();
      if (drawer && cart.sections) await drawer.renderContents(cart);
      else window.location.reload();
      notify();
    }
  });
})();
